import './account.component.scss'
import '../../application/sea-forms/index.scss'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

const open = document.querySelector('[data-open-account-navigation]')
const close = document.querySelector('[data-close-account-navigation]')
const navigation = document.querySelector('.account-navigation')

if (navigation) {
  open.addEventListener('click', () => {
    document.documentElement.classList.add('account-navigation-open')
    disableBodyScroll(navigation)
  })
}
if (close) {
  close.addEventListener('click', () => {
    document.documentElement.classList.remove('account-navigation-open')
    enableBodyScroll(navigation)
  })
}
